// src/hooks/useJobOptions.ts
import { useTranslation } from "react-i18next";

export const useJobOptions = () => {
  const { t } = useTranslation("job"); // using job namespace

  const INCOME_TYPE_OPTIONS = {
    MONTHLY: t("incomeMonthly"),
  };

  const HIRE_TYPE_OPTIONS = [
    { label: t("hirePermanent"), value: "hirePermanent" },
    { label: t("hireContract"), value: "hireContract" },
    { label: t("hireGovernment"), value: "hireGovernment" },
    { label: t("hireState"), value: "hireState" },
  ];

  const BANK_NAME_OPTIONS = [
    { value: "kbank", label: t("bankKbank") },
    { value: "scb", label: t("bankScb") },
    { value: "ktb", label: t("bankKtb") },
    { value: "bbl", label: t("bankBbl") },
    { value: "bay", label: t("bankBay") },
  ];

  const JOB_TYPES = [
    { value: "employee", label: t("jobEmployee") },
    { value: "corporation", label: t("jobCorporation") },
    { value: "individual", label: t("jobIndividual") },
  ];

  const JOB_NAME_LIST = [
    { value: "พนักงานบริษัทเอกชน", label: t("jobNamePrivate") },
    { value: "พนักงานรัฐวิสาหกิจ", label: t("jobNameState") },
    { value: "ข้าราชการ", label: t("jobNameOfficial") },
    { value: "ครู/อาจารย์", label: t("jobNameTeacher") },
    { value: "แพทย์/พยาบาล", label: t("jobNameDoctor") },
    { value: "วิศวกร", label: t("jobNameEngineer") },
    { value: "นักกฎหมาย/ทนายความ", label: t("jobNameLawyer") },
    { value: "นักบัญชี", label: t("jobNameAccountant") },
    { value: "นักการตลาด", label: t("jobNameMarketing") },
    { value: "นักวิเคราะห์ข้อมูล (Data Analyst)", label: t("jobNameAnalyst") },
    { value: "โปรแกรมเมอร์/นักพัฒนาซอฟต์แวร์", label: t("jobNameProgrammer") },
    { value: "พนักงานฝ่ายผลิต", label: t("jobNameFactory") },
    { value: "พนักงานขาย", label: t("jobNameSales") },
    { value: "เจ้าหน้าที่บริการลูกค้า", label: t("jobNameService") },
    { value: "ที่ปรึกษาทางธุรกิจ", label: t("jobNameConsultant") },
    { value: "อื่นๆ", label: t("jobNameOther") },
  ];

  const JOB_LEVEL_LIST = [
    { value: "เจ้าหน้าที่ปฏิบัติการ", label: t("jobLevelStaff") },
    { value: "หัวหน้างาน", label: t("jobLevelSupervisor") },
    { value: "ผู้จัดการ", label: t("jobLevelManager") },
  ];

  return {
    INCOME_TYPE_OPTIONS,
    HIRE_TYPE_OPTIONS,
    BANK_NAME_OPTIONS,
    JOB_TYPES,
    JOB_NAME_LIST,
    JOB_LEVEL_LIST,
  };
};




// export const useJobOptions = () => {
//   const { t } = useTranslation("job"); // assuming you registered this under the "job" namespace

//   const INCOME_TYPE_OPTIONS = {
//     MONTHLY: t("incomeMonthly"),
//   };

//   const HIRE_TYPE_OPTIONS = [
//     { label: t("hirePermanent"), value: t("hirePermanent") },
//     { label: t("hireContract"), value: t("hireContract") },
//     { label: t("hireGovernment"), value: t("hireGovernment") },
//     { label: t("hireState"), value: t("hireState") },
//   ];

//   const BANK_NAME_OPTIONS = [
//     { value: "kbank", label: t("bankKbank") },
//     { value: "scb", label: t("bankScb") },
//     { value: "ktb", label: t("bankKtb") },
//     { value: "bbl", label: t("bankBbl") },
//     { value: "bay", label: t("bankBay") },
//   ];

//   const JOB_TYPES = [
//     { value: "employee", label: t("jobEmployee") },
//     { value: "corporation", label: t("jobCorporation") },
//     { value: "individual", label: t("jobIndividual") },
//   ];

//   const JOB_NAME_LIST = [
//     { value: "พนักงานบริษัทเอกชน", label: t("jobNamePrivate") },
//     { value: "พนักงานรัฐวิสาหกิจ", label: t("jobNameState") },
//     { value: "ข้าราชการ", label: t("jobNameOfficial") },
//     { value: "ครู/อาจารย์", label: t("jobNameTeacher") },
//     { value: "แพทย์/พยาบาล", label: t("jobNameDoctor") },
//     { value: "วิศวกร", label: t("jobNameEngineer") },
//     { value: "นักกฎหมาย/ทนายความ", label: t("jobNameLawyer") },
//     { value: "นักบัญชี", label: t("jobNameAccountant") },
//     { value: "นักการตลาด", label: t("jobNameMarketing") },
//     { value: "นักวิเคราะห์ข้อมูล (Data Analyst)", label: t("jobNameAnalyst") },
//     { value: "โปรแกรมเมอร์/นักพัฒนาซอฟต์แวร์", label: t("jobNameProgrammer") },
//     { value: "พนักงานฝ่ายผลิต", label: t("jobNameFactory") },
//     { value: "พนักงานขาย", label: t("jobNameSales") },
//     { value: "เจ้าหน้าที่บริการลูกค้า", label: t("jobNameService") },
//     { value: "ที่ปรึกษาทางธุรกิจ", label: t("jobNameConsultant") },
//     { value: "อื่นๆ", label: t("jobNameOther") },
//   ];

//   const JOB_LEVEL_LIST = [
//     { value: "เจ้าหน้าที่ปฏิบัติการ", label: t("jobLevelStaff") },
//     { value: "หัวหน้างาน", label: t("jobLevelSupervisor") },
//     { value: "ผู้จัดการ", label: t("jobLevelManager") },
//   ];

//   return {
//     INCOME_TYPE_OPTIONS,
//     HIRE_TYPE_OPTIONS,
//     BANK_NAME_OPTIONS,
//     JOB_TYPES,
//     JOB_NAME_LIST,
//     JOB_LEVEL_LIST,
//   };
// };
